var map = {
	"./components/corporate-check/corporate-check.module": [
		"./src/app/components/corporate-check/corporate-check.module.ts",
		"default~components-corporate-check-corporate-check-module~pages-subscriptions-subscriptions-module",
		"components-corporate-check-corporate-check-module"
	],
	"./pages/access-denied/access-denied.module": [
		"./src/app/pages/access-denied/access-denied.module.ts",
		"pages-access-denied-access-denied-module"
	],
	"./pages/activity-log/activity-log.module": [
		"./src/app/pages/activity-log/activity-log.module.ts",
		"default~pages-activity-log-activity-log-module~pages-check-status-check-status-module~pages-reports-~2ca75c01",
		"pages-activity-log-activity-log-module"
	],
	"./pages/aml-alerts/aml-alerts.module": [
		"./src/app/pages/aml-alerts/aml-alerts.module.ts",
		"default~pages-aml-alerts-aml-alerts-module~pages-report-details-report-details-module",
		"pages-aml-alerts-aml-alerts-module"
	],
	"./pages/aml-screening/aml-screening.module": [
		"./src/app/pages/aml-screening/aml-screening.module.ts"
	],
	"./pages/aml-search/aml-search.module": [
		"./src/app/pages/aml-search/aml-search.module.ts",
		"default~pages-aml-search-aml-search-module~pages-bulk-upload-result-bulk-upload-result-module"
	],
	"./pages/bulk-upload-result/bulk-upload-result.module": [
		"./src/app/pages/bulk-upload-result/bulk-upload-result.module.ts",
		"default~pages-aml-search-aml-search-module~pages-bulk-upload-result-bulk-upload-result-module",
		"pages-bulk-upload-result-bulk-upload-result-module"
	],
	"./pages/bulk-upload/bulk-upload.module": [
		"./src/app/pages/bulk-upload/bulk-upload.module.ts"
	],
	"./pages/check-status/check-status.module": [
		"./src/app/pages/check-status/check-status.module.ts",
		"default~pages-activity-log-activity-log-module~pages-check-status-check-status-module~pages-reports-~2ca75c01",
		"pages-check-status-check-status-module"
	],
	"./pages/consumtion-report/consumtion-report.module": [
		"./src/app/pages/consumtion-report/consumtion-report.module.ts",
		"pages-consumtion-report-consumtion-report-module"
	],
	"./pages/corp-report/corp-report.module": [
		"./src/app/pages/corp-report/corp-report.module.ts",
		"default~pages-corp-report-corp-report-module~pages-report-details-report-details-module",
		"pages-corp-report-corp-report-module"
	],
	"./pages/corporate-search/corporate-search.module": [
		"./src/app/pages/corporate-search/corporate-search.module.ts",
		"pages-corporate-search-corporate-search-module"
	],
	"./pages/coupons/coupons.module": [
		"./src/app/pages/coupons/coupons.module.ts"
	],
	"./pages/customize/customize.module": [
		"./src/app/pages/customize/customize.module.ts",
		"pages-customize-customize-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/dev-ops/dev-ops.module": [
		"./src/app/pages/dev-ops/dev-ops.module.ts"
	],
	"./pages/digital-verification/digital-verification.module": [
		"./src/app/pages/digital-verification/digital-verification.module.ts",
		"pages-digital-verification-digital-verification-module"
	],
	"./pages/doc-extraction/doc-extraction.module": [
		"./src/app/pages/doc-extraction/doc-extraction.module.ts",
		"pages-doc-extraction-doc-extraction-module"
	],
	"./pages/faq/faq.module": [
		"./src/app/pages/faq/faq.module.ts",
		"pages-faq-faq-module"
	],
	"./pages/invoices/invoices.module": [
		"./src/app/pages/invoices/invoices.module.ts",
		"pages-invoices-invoices-module"
	],
	"./pages/live-check/live-check.module": [
		"./src/app/pages/live-check/live-check.module.ts"
	],
	"./pages/notification/notification.module": [
		"./src/app/pages/notification/notification.module.ts",
		"pages-notification-notification-module"
	],
	"./pages/override-report/override-report.module": [
		"./src/app/pages/override-report/override-report.module.ts",
		"pages-override-report-override-report-module"
	],
	"./pages/payment/payment.module": [
		"./src/app/pages/payment/payment.module.ts",
		"pages-payment-payment-module"
	],
	"./pages/pricing-new/pricing-new.module": [
		"./src/app/pages/pricing-new/pricing-new.module.ts",
		"pages-pricing-new-pricing-new-module"
	],
	"./pages/report-details/report-details.module": [
		"./src/app/pages/report-details/report-details.module.ts",
		"default~pages-corp-report-corp-report-module~pages-report-details-report-details-module",
		"default~pages-aml-alerts-aml-alerts-module~pages-report-details-report-details-module",
		"pages-report-details-report-details-module"
	],
	"./pages/reports/reports.module": [
		"./src/app/pages/reports/reports.module.ts",
		"default~pages-activity-log-activity-log-module~pages-check-status-check-status-module~pages-reports-~2ca75c01",
		"pages-reports-reports-module"
	],
	"./pages/roles-new/roles.module": [
		"./src/app/pages/roles-new/roles.module.ts",
		"pages-roles-new-roles-module"
	],
	"./pages/settings/settings.module": [
		"./src/app/pages/settings/settings.module.ts",
		"pages-settings-settings-module"
	],
	"./pages/subscriptions/subscriptions.module": [
		"./src/app/pages/subscriptions/subscriptions.module.ts",
		"default~components-corporate-check-corporate-check-module~pages-subscriptions-subscriptions-module",
		"pages-subscriptions-subscriptions-module"
	],
	"./pages/theming/theming.module": [
		"./src/app/pages/theming/theming.module.ts",
		"pages-theming-theming-module"
	],
	"./pages/user-home/user-home.module": [
		"./src/app/pages/user-home/user-home.module.ts",
		"pages-user-home-user-home-module"
	],
	"./shared/test/test.module": [
		"./src/app/shared/test/test.module.ts",
		"shared-test-test-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;